'use client';
import { Link, usePathname } from '@/i18n/routing';
import { useTranslations } from 'next-intl';
import { useContext, useEffect, useState } from 'react';
import { ReportContext } from '@/app/providers/reportProvider';

export function TarrifBanner({ keyword }) {
  const pathName = usePathname();
  const t = useTranslations('tarrif_cta');
  const [isActive, setIsActive] = useState();
  const report = useContext(ReportContext);

  useEffect(() => {
    function onScroll() {
      const section = document.getElementById('title-banner');
      const secHeight = section && section.clientHeight;

      if (window.scrollY >= secHeight) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    }

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [report]);

  return (
    <div
      className={`fixed bottom-0 mb-12 hidden sm:block sm:mb-2 left-1/2 -translate-x-1/2 z-50 w-full max-w-3xl bg-[url('/tarrif_cta_bg.webp')] bg-cover p-2 sm:rounded-md shadow-lg tarrifBanner ${
        isActive ? 'active' : ''
      }`}
    >
      <div>
        <p className="text-white text-sm sm:text-lg font-semibold uppercase">
          {t('title')} <span className="text-blue-400">{keyword}</span>
        </p>
        <div className="mt-1 text-white sm:flex gap-y-2 sm:gap-x-5 items-center text-sm text-center space-y-2">
          <p className="text-start text-xs">{t('content')}</p>
          <Link
            className="inline-block px-2 py-1 w-full sm:w-1/4 rounded-md sm:rounded-xl bg-blue-800 border border-white text-white text-xs sm:text-sm"
            href={`${pathName}/request-ustarrif-impact-analysis`}
          >
            {t('cta')}
          </Link>
        </div>
      </div>
    </div>
  );
}
